import type {
  GuestBookingFeedbackForm,
  SubmitBookingFeedbackRequest,
  SubmitBookingFeedbackResponse,
} from '@mds/shared/types/booking-feedback';

import { api } from '@/lib/api';

/**
 * The emailed-link endpoints for booking feedback — see `backend/docs/booking-feedback.md`.
 *
 * The token is the client's only key: there is no sign-in. An unknown token is
 * `404 BOOKING_FEEDBACK_NOT_FOUND`; an unanswered one past its 30 days is
 * `410 BOOKING_FEEDBACK_EXPIRED`.
 */

/** The API path for one invitation; the emailed link opens the client route of the same shape. */
const feedbackPath = (token: string) => `bookings/feedback/${encodeURIComponent(token)}`;

/** The booking, the two standard fields, the custom questions, and `alreadySubmitted`. */
export const getBookingFeedbackForm = (token: string): Promise<GuestBookingFeedbackForm> =>
  api.get<{ data: GuestBookingFeedbackForm }>(feedbackPath(token)).then((r) => r.data);

/** One response per invitation: a second send is `409 BOOKING_FEEDBACK_ALREADY_SUBMITTED`. */
export const submitBookingFeedback = (
  token: string,
  body: SubmitBookingFeedbackRequest,
): Promise<SubmitBookingFeedbackResponse> =>
  api.post<{ data: SubmitBookingFeedbackResponse }>(feedbackPath(token), body).then((r) => r.data);
